import React, {FC} from "react";
import {useModal} from "../../../../lib/src/components/layout/ModalProvider";
import {ProjectVisit} from "@traas/lib/src/api/dto/ProjectVisit";
import {ContextMenuOption} from "../../../../lib/src/components/data/ContextMenuOption";
import {EditProjectVisitModal} from "../../modals/ProjectVisits/EditProjectVisitModal";
import {DeleteProjectVisitModal} from "../../modals/DeleteProjectVisitModal";
import {faPencil, faTrash} from "@fortawesome/free-solid-svg-icons";

export const ProjectVisitContextMenu: FC<{ projectVisit: ProjectVisit, close: () => void, onUpdated?: () => void }> = (props) => {
  const editVisitModal = useModal({title: 'Werkbezoek aanpassen', body: <EditProjectVisitModal visit={props.projectVisit} onFinished={() => props.onUpdated?.()} />, size: 'lg'})
  const deleteVisitModal = useModal({title: 'Werkbezoek verwijderen', body: <DeleteProjectVisitModal visit={props.projectVisit} />, size: 'lg'})

  return <div className={'z-30 absolute right-0 top-11 w-64 border border-slate-200 rounded-sm'}>
    <div className={'bg-white rounded-sm'}>
      <div className={'text-sm font-medium text-blue-800 uppercase px-3 py-1 border-b border-slate-200'}>Acties</div>
      <ContextMenuOption icon={faPencil} text={'Bewerken'} close={props.close} onClick={() => editVisitModal.open()} />
      <ContextMenuOption icon={faTrash} text={'Verwijderen'} close={props.close} onClick={() => deleteVisitModal.open()} />
    </div>
  </div>
}